import React from "react";

const PlaceOrderButton = ({ handlePlaceOrder }) => {
  return (
    <button className="checkout-button" onClick={handlePlaceOrder}>
      Place Order
    </button>
  );
};

export default PlaceOrderButton;
